import { render, staticRenderFns } from "./CancelSubLicence.vue?vue&type=template&id=0263047f&scoped=true"
import script from "./CancelSubLicence.vue?vue&type=script&lang=js"
export * from "./CancelSubLicence.vue?vue&type=script&lang=js"
import style0 from "./CancelSubLicence.vue?vue&type=style&index=0&id=0263047f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0263047f",
  null
  
)

/* custom blocks */
import block0 from "./CancelSubLicence.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports